import { render, staticRenderFns } from "./PartnerExternalLinksModal.vue?vue&type=template&id=2dbe4122&"
import script from "./PartnerExternalLinksModal.vue?vue&type=script&lang=js&"
export * from "./PartnerExternalLinksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports